"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "12062550-7a32-40a1-b935-2bfb2ba6c222",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "894b2880-0840-4969-9d9d-3785e0947d17",
    x1: 60.01,
    y1: 60,
    x2: 167.99,
    y2: 168.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "vodafone-bonus-hi"), /*#__PURE__*/React.createElement("g", {
    id: "6a12a489-f25e-40af-8950-943055cbd1c0",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.44,66.58l.71-2.92c.71-2.9,7.11-28.52,13.91-34.71a20,20,0,0,1,26.39,0,16.23,16.23,0,0,1,0,24.45c-6.77,6.15-34.87,11.94-38.05,12.59ZM125.25,27.8a15.75,15.75,0,0,0-10.6,4c-4.48,4.07-9.63,20.84-12,29.83,9.86-2.15,28.68-6.9,33.22-11h0a12.42,12.42,0,0,0,0-18.8A15.75,15.75,0,0,0,125.25,27.8Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56,66.58l-3-.6c-3.18-.64-31.28-6.43-38.05-12.59h0a16.23,16.23,0,0,1,0-24.45,20,20,0,0,1,26.39,0c6.81,6.19,13.21,31.81,13.91,34.71ZM66.75,27.8a15.75,15.75,0,0,0-10.6,4,12.42,12.42,0,0,0,0,18.8h0c4.55,4.13,23.37,8.88,33.22,11-2.38-9-7.54-25.76-12-29.83A15.75,15.75,0,0,0,66.75,27.8Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,96v70a2,2,0,0,0,2,2H166a2,2,0,0,0,2-2V96Z",
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,166H26a2,2,0,0,1-2-2v2a2,2,0,0,0,2,2H166a2,2,0,0,0,2-2v-2A2,2,0,0,1,166,166Z",
    transform: "translate(0)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,96H18a2,2,0,0,1-2-2V66a2,2,0,0,1,2-2H174a2,2,0,0,1,2,2V94A2,2,0,0,1,174,96Z",
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 64,
    width: 16,
    height: 104,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24 96 96 168 168 168 168 96 24 96",
    opacity: 0.2,
    fill: "url(#894b2880-0840-4969-9d9d-3785e0947d17)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,94H18a2,2,0,0,1-2-2v2a2,2,0,0,0,2,2H174a2,2,0,0,0,2-2V92A2,2,0,0,1,174,94Z",
    transform: "translate(0)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,60h8a4,4,0,0,1,4,4v0a0,0,0,0,1,0,0H88a0,0,0,0,1,0,0v0A4,4,0,0,1,92,60Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,60h8a4,4,0,0,1,4,4v0a0,0,0,0,1,0,0H88a0,0,0,0,1,0,0v0A4,4,0,0,1,92,60Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  })));
}

var _default = ic_bonus;
exports.default = _default;